<template>
  <section class="listing">
    <div class="header">
      <div class="title">Bloqueios ({{ customers.length }})</div>
    </div>
    <form @submit.prevent class="form form-search">
      <input v-model="search" type="text" placeholder="Pesquisar..." />
    </form>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-else style="margin-top: 10px">
        <div v-if="filtered.length === 0" class="empty-state">
          Nenhum assinante bloqueado no momento.
        </div>
        <div v-else class="list-cards">
        <div v-for="c in filtered" :key="c.id" class="list list-blocked">
          <div class="data">
            <div class="main-data">{{ c.name }}</div>
            <div class="detail-data">{{ c.email }}</div>
            <div class="detail-data">{{ c.phone || '—' }}</div>
            <div class="detail-data blocked-tags">
              <span
                v-for="platform in blockedPlatforms(c)"
                :key="`${c.id}-${platform}`"
                class="blocked-tag"
              >
                {{ platform }}
              </span>
            </div>
          </div>
          <div class="actions">
            <button @click="openDetail(c)" class="button-action">
              <i class="fas fa-eye"></i><span>DETALHE</span>
            </button>
          </div>
        </div>
        </div>
      </div>
    </transition>

    <BlockDetail
      v-if="selectedCustomer"
      :customer="selectedCustomer"
      @close="selectedCustomer = null"
      @unblocked="onUnblocked"
    />
  </section>
</template>

<script>
import logger from '../../logger'
import { getAll } from '../api/blocks'
import BlockDetail from './BlockDetail.vue'

export default {
  name: 'blocks',
  components: { BlockDetail },
  data () {
    return {
      loading: true,
      customers: [],
      search: '',
      selectedCustomer: null
    }
  },
  computed: {
    filtered () {
      if (!this.search) return this.customers
      const term = this.search.toUpperCase()
      return this.customers.filter(c =>
        Object.keys(c).some(key => String(c[key] || '').toUpperCase().includes(term))
      )
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    isBlockedToken (value) {
      return String(value || '').trim().toLowerCase() === 'bloqueado'
    },
    tokenNinjaValue (customer) {
      return customer.tokenNinja != null ? customer.tokenNinja : customer.token_ninja
    },
    blockedPlatforms (customer) {
      const platforms = []
      if (this.isBlockedToken(customer.token)) platforms.push('Profit')
      if (this.isBlockedToken(this.tokenNinjaValue(customer))) platforms.push('NinjaTrader')
      return platforms
    },
    async getData () {
      try {
        this.loading = true
        const data = await getAll()
        this.customers = Array.isArray(data) ? data : []
      } catch (error) {
        logger.error(error, this)
        this.customers = []
      } finally {
        this.loading = false
      }
    },
    openDetail (customer) {
      this.selectedCustomer = customer
    },
    async onUnblocked () {
      this.selectedCustomer = null
      await this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.empty-state {
  margin-top: 10px;
}

.list-blocked {
  border-left: 4px solid #c0392b;
}

.blocked-tags {
  margin-top: 6px;
}

.blocked-tag {
  display: inline-block;
  margin-right: 6px;
  padding: 2px 8px;
  border-radius: 4px;
  background: rgba(192, 57, 43, 0.15);
  color: #c0392b;
  font-size: 0.85em;
  font-weight: 600;
}
</style>
